import { Table } from 'antd'
import styled from 'styled-components'

const SimpleTable = styled(Table)`
  &&& {
    .ant-table {
      color: #333;
      font-size: 12px;
      background-color: #F6F7F8;

      table {
        text-align: center;
      }
    }

    .ant-table-content {}

    .ant-table-body {}

    .ant-table-thead {
      tr {
        th {
          background-color: #F6F7F8;
          color: #999;
          text-align: center;
        }
      }
    }

    .ant-table-thead {
      tr th { padding: 11px; }
    }

    .ant-table-tbody {
      background-color: #F6F7F8;
      tr td { padding: 11px; }
    }


  }
`

export default SimpleTable
